import "../styles/Pricing.css";
import {Badge} from "./Badge";
import * as React from "react";
import {Button, ButtonType} from "./Button";
import {Config} from "../Config";
import {ToolIcons} from "./Tool";
import Odometer from "./Odometer";
import {useState} from "react";

interface PricingProps {

}
export const Pricing : React.FC<PricingProps> = (props) => {
    const [multiPackageHasAdditionalPackage, setMultiPackageHasAdditionalPackage] = useState(false);
    const [singlePackageHasAdditionalPackage, setSinglePackageHasAdditionalPackage] = useState(false);
    const [subscriptionPackageHasAdditionalPackage, setSubscriptionPackageHasAdditionalPackage] = useState(false);

    return <div className="pricing section" id={Config.PageSections.Pricing}>
        <Badge className={"center animate-from-bottom"}>Pricing</Badge>
        <h2 className={"animate-from-bottom delay-1"}>
            Simple & transparent pricing without hidden costs.
        </h2>
        <p className="subtitle animate-from-bottom delay-2">
            Flexible plans that scale with your needs.
        </p>
        <div className="cards">
            <div className="card standard animate-from-bottom delay-3">
                <h3 className={"font-body-L"}>{ToolIcons.Computer} SINGLE LANDING PAGE</h3>
                <p className={"font-body-M-Regular"}>A conversion-focused landing page perfect for launches, campaigns, or portfolios.</p>
                <Odometer currency="€" value={singlePackageHasAdditionalPackage ? Config.PricingPackages.SinglePackage.Basic + Config.PricingPackages.SinglePackage.Additional : Config.PricingPackages.SinglePackage.Basic} /><div className={"plus font-body-M"}>+</div>
                <Button classes={["btn-light", "btn-md"]} type={ButtonType.Link} onClick={"#" + Config.PageSections.Booking}>Get Started</Button>
                <div className="list">
                    <div className="list-item font-body-S">Custom design in Figma</div>
                    <div className="list-item font-body-S">Responsive, fast, and SEO-friendly</div>
                    <div className="list-item font-body-S">Development in Framer (add to package)</div>
                    <div className="list-item font-body-S">3 rounds of feedback & iteration</div>
                    <div className="list-item font-body-S">2 week delivery</div>
                    <div className={"additional-package"}>
                        <div className={"pricing-checkbox"}>
                            <input type={"checkbox"} id={"single-package"} onChange={e => setSinglePackageHasAdditionalPackage(!singlePackageHasAdditionalPackage)}/>
                            <span className="checkmark"></span>
                        </div>
                        <label htmlFor={"single-package"}>Framer Development + <strong>€1,200</strong></label>
                    </div>
                </div>
            </div>
            <div className="card business animate-from-bottom delay-4">
                <h3 className={"font-body-L"}>{ToolIcons.Devices} MULTI PAGE WEBSITE</h3>
                <p className={"font-body-M-Regular"}>A custom multi-page website, designed to scale with your brand. Ideal for growing startups or businesses.</p>
                <Odometer currency="€" value={multiPackageHasAdditionalPackage ? Config.PricingPackages.MultiPackage.Basic + Config.PricingPackages.MultiPackage.Additional : Config.PricingPackages.MultiPackage.Basic} /><div className={"plus font-body-M"}>+</div>
                <Button classes={["btn-light", "btn-md"]} type={ButtonType.Link} onClick={"#" + Config.PageSections.Booking}>Get Started</Button>
                <div className="list">
                    <div className="list-item font-body-S">Custom design in Figma (up to 6 pages)</div>
                    <div className="list-item font-body-S">Responsive, accessible, and SEO-friendly</div>
                    <div className="list-item font-body-S">Development in Framer (add to package)</div>
                    <div className="list-item font-body-S">2 rounds of feedback & iteration</div>
                    <div className="list-item font-body-S">Delivery in 2–4 weeks</div>
                    <div className={"additional-package"}>
                        <div className={"pricing-checkbox"}>
                            <input type={"checkbox"} id={"multipage-package"} onChange={e => setMultiPackageHasAdditionalPackage(!multiPackageHasAdditionalPackage)}/>
                            <span className="checkmark"></span>
                        </div>
                        <label htmlFor={"multipage-package"}>Framer Development + <strong>€1,200</strong></label>
                    </div>
                </div>
            </div>
            <div className="card boost animate-from-bottom delay-5">
                <div className="background-color">
                    <h3 className={"font-body-L"}>{ToolIcons.Verified} DESIGN SUBSCRIPTION</h3>
                    <p className={"font-body-M-Regular"}>Ongoing, on-demand design and Framer support. Perfect for teams that need consistent, high-quality work.</p>
                    <Odometer currency="€" value={subscriptionPackageHasAdditionalPackage ? Config.PricingPackages.SubscriptionPackage.Basic + Config.PricingPackages.SubscriptionPackage.Additional : Config.PricingPackages.SubscriptionPackage.Basic} /><div className={"plus font-body-M"}>+</div>
                    <Button classes={["btn-primary", "btn-md"]} type={ButtonType.Link} onClick={"#" + Config.PageSections.Booking}>Book a call</Button>
                    <div className="list">
                        <div className="list-item font-body-S">Design + No-Code at your service</div>
                        <div className="list-item font-body-S">Product + Website design</div>
                        <div className="list-item font-body-S">Pause or cancel anytime</div>
                        <div className="list-item font-body-S">Average 48 hour delivery</div>
                        <div className="list-item font-body-S">Available 5 days/week</div>
                        <div className={"additional-package"}>
                            <div className={"pricing-checkbox"}>
                                <input type={"checkbox"} id={"subscription-package"} onChange={e => setSubscriptionPackageHasAdditionalPackage(!subscriptionPackageHasAdditionalPackage)}/>
                                <span className="checkmark"></span>
                            </div>
                            <label htmlFor={"subscription-package"}>Custom Development + <strong>€2,000</strong></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
